import React from 'react'

interface PartnerProps {
  name: string;
  logo: string;
  href: string;
}

const partners: PartnerProps[] = [
  {
    name: "Garmin",
    logo: "/garmin.png",
    href: "https://www.garmin.com"
  },
  {
    name: "DAN",
    logo: "/dan-world.png",
    href: "https://dan.org"
  },
  {
    name: "Dive Assure",
    logo: "/dive-assure.png",
    href: "https://www.diveassure.com"
  },
  {
    name: "Suunto",
    logo: "/suunto-logo.png",
    href: "https://www.suunto.com"
  }
]

const PartnersSection: React.FC = () => {
  return (
    <section className="py-20 relative z-20">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Trusted by Industry Leaders</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We partner with leading dive computer manufacturers, dive safety organizations, 
            and insurance providers to enhance your diving experience and safety.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center max-w-4xl mx-auto">
          {partners.map((partner) => (
            <a
              key={partner.name}
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300"
            >
              <img
                src={partner.logo}
                alt={`${partner.name} logo`}
                className="h-12 md:h-16 w-auto object-contain transition-transform group-hover:scale-105"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default PartnersSection 